import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LangService } from "../../services/lang.service";

const VIDEO_FILE_EXTENSIONS = ['mp4', 'webm', 'ogg', 'ogv', 'mov', 'm4v'];

@Component({
    selector: 'app-block-video',
    templateUrl: './block-video.component.html',
    styleUrls: ['./block-video.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BlockVideoComponent implements OnInit {

    @Input() item: any;
    videoUrl: any = null;
    fileUrl: string | null = null;
    transcript: string = '';
    toggleTranscript = false;

    constructor(
        protected sanitizer: DomSanitizer,
        public lang: LangService
    ) {}

    ngOnInit() {
        const rawUrl = this.item?.data?.video_url?.trim?.();
        if (!rawUrl) {
            return;
        }

        this.transcript = this.item?.data?.transcript || '';

        // A file uploaded to the media library plays natively; an embed does not.
        if (this.isVideoFile(rawUrl)) {
            this.fileUrl = rawUrl;
            return;
        }

        const videoId = this.extractVideoId(rawUrl);

        if (videoId) {
            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                `https://assets.mysupportspace.org.uk/youtube.html?v=${videoId}`
            );
        } else {
            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
        }
    }

    isVideoFile(url: string): boolean {
        const path = url.split('?')[0].split('#')[0];
        const extension = path.split('.').pop()?.toLowerCase() ?? '';

        return VIDEO_FILE_EXTENSIONS.includes(extension);
    }

    extractVideoId(url: string): string {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        return match ? match[1] : '';
    }
}
